import script from "./BidView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BidView.vue?vue&type=script&lang=ts&setup=true"

import "./BidView.vue?vue&type=style&index=0&id=e96e5acc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e96e5acc"]])

export default __exports__